import { Typography } from 'antd';
import { FontSizeType } from '../types';
import { ArrowDownOutlined, ArrowUpOutlined, MinusOutlined } from '@ant-design/icons';
import { GREEN1, RED1 } from '../constants/color';

export const compare = (
  a: string | number | null,
  b: string | number | null
) => {
  if (typeof a === 'number' && typeof b === 'number') return a - b;
  return (a !== null ? a.toString() : '').localeCompare(
    b !== null ? b.toString() : ''
  );
};

export const setFont = (
  text: string,
  fontSize?: FontSizeType,
  exportColumns?: string
) => (
  <Typography.Text key={exportColumns} style={{ fontSize: fontSize }}>
    {text}
  </Typography.Text>
);

export const compareLastDataGrowthAnalysis = (growthValue: string) => {
  const firstChar = growthValue[0];
  return (
    <>
      {firstChar === '-' ? (
        <ArrowDownOutlined style={{ color: RED1 }} />
      ) : growthValue === '' ? (
        <MinusOutlined />
      ) : (
        <ArrowUpOutlined style={{ color: GREEN1 }} />
      )}
      {growthValue !== '' && `${growthValue}%`}
    </>
  );
};
